export default __webpack_public_path__ + "static/media/polyfeed_bag.ecc7d9a0.png";